import { computed } from 'vue';
import { useInfiniteVueQuery } from '@libs/use';
import { EPaymentsResult, EPayment } from '@libs/api-reference';

import * as API from '../requests';
import { CASH_QUERY_KEYS } from '../constants';

export default function useInfiniteGetDepositsQuery() {
  const {
    result,
    execute: getDeposits,
    isPending: isLoadingDeposits,
    isSuccess: isSuccessLoadingDeposits,
    loadMoreRef,
  } = useInfiniteVueQuery<EPaymentsResult, EPayment>(API.getEPayments, {
    key: CASH_QUERY_KEYS.deposits,
    staleTime: 1000,
  });

  const deposits = computed(() => result.value || []);

  return {
    getDeposits,
    deposits,
    isLoadingDeposits,
    isSuccessLoadingDeposits,
    loadMoreRef,
  };
}
